export default __webpack_public_path__ + "static/media/hero-image-atc.9e0cd0a6.png";